import { TZDate } from '@date-fns/tz';
import { format as formatDate } from 'date-fns';

import { logError } from '@/providers/ErrorTracking';

const formatWithTimezone = ({
  datetime,
  timezone,
  format,
}: {
  datetime: string;
  timezone: string | undefined | null;
  format: string;
}): string => {
  try {
    return formatDate(new TZDate(datetime, timezone ?? undefined), format);
  } catch (error) {
    logError(error);
    return formatDate(new TZDate(datetime), format);
  }
};

export const withYear = (datetime: string, timezone: string): string =>
  formatWithTimezone({
    datetime,
    format: 'LLLL do, yyyy',
    timezone,
  });

export const yearOnly = (time: string): string => formatDate(new TZDate(time, 'UTC'), 'yyyy');

export const monthYearShort = (time: string): string => formatDate(new TZDate(time, 'UTC'), 'MMM yyyy');

export const monthYearLong = (time: string): string => formatDate(new TZDate(time, 'UTC'), 'MMMM yyyy');

export const abbreviatedTimezone = ({ timezone }: { timezone: string }): string => {
  try {
    return new Date().toLocaleTimeString('en-us', { timeZone: timezone, timeZoneName: 'short' }).split(' ')[2];
  } catch (error) {
    logError(error);
    return '';
  }
};

export const unabridgeTimezone = ({ timezone }: { timezone: string }): string => {
  try {
    return new Date()
      .toLocaleTimeString('en-us', { timeZone: timezone, timeZoneName: 'long' })
      .split(' ')
      .slice(2)
      .join(' ');
  } catch (error) {
    logError(error);
    return '';
  }
};

export const timeOnly = (datetime: string, timezone: string): string =>
  formatWithTimezone({
    datetime,
    format: 'h:mm a',
    timezone,
  });
